export default "__VITE_ASSET__DVCDtzRt__"